import React, { useContext, useMemo } from 'react';
import { Box } from '@zillow/constellation';
import { ThemeContext } from 'styled-components';
import PropTypes from 'prop-types';
import { useLastValidRefinanceValues, useRefinanceColors, abbr } from './RefinanceCalculator.utils.js';
import withDimensions from '../PaymentDonutChart/withDimensions.js';
import PropInterpolatorWrapper from '../PaymentDonutChart/Chart/common/PropInterpolator.js';
import BarChart from '../PaymentDonutChart/BarChart/BarChart.js';

var YEAR_MONTHS = 12;
var RefinanceBarGraphBase = function RefinanceBarGraphBase(_ref) {
  var containerWidth = _ref.containerWidth;
  var values = useLastValidRefinanceValues();
  var colors = useRefinanceColors();
  var theme = useContext(ThemeContext);
  var dataPoints = useMemo(function () {
    var newDataPoints = [{
      label: 'Costs',
      value: values.fields.fees,
      color: colors.costsColor
    }];
    var maybePlotDataPoint = function maybePlotDataPoint(_ref2) {
      var yearsAtDataPoint = _ref2.yearsAtDataPoint;
      var monthsAtDataPoint = yearsAtDataPoint * YEAR_MONTHS;
      if (monthsAtDataPoint === 0 || values.calculations.savingsSchedule.length < monthsAtDataPoint) {
        return;
      }
      newDataPoints.push({
        label: yearsAtDataPoint + "yrs",
        value: values.calculations.savingsSchedule[monthsAtDataPoint - 1].totalSavings,
        color: colors.lifetimeSavingsColor
      });
    };
    var totalYears = values.calculations.savingsSchedule.length / YEAR_MONTHS;
    maybePlotDataPoint({
      yearsAtDataPoint: 1
    });
    maybePlotDataPoint({
      yearsAtDataPoint: Math.round(totalYears / 3 * 2)
    });
    maybePlotDataPoint({
      yearsAtDataPoint: Math.floor(totalYears)
    });
    return newDataPoints.map(function (item) {
      return Object.assign({}, item, {
        value: item.value > 0 ? item.value : 0
      });
    });
  }, [values.calculations.savingsSchedule, values.fields.fees, colors.costsColor, colors.lifetimeSavingsColor]);
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      fontSize: '$fontSizes.body',
      height: '150px'
    }
  }, /*#__PURE__*/React.createElement(BarChart, {
    legend: false,
    data: dataPoints,
    width: containerWidth,
    height: 150,
    tickTextStroke: theme.constellation.colors.textLight,
    axesColor: theme.constellation.colors.backgroundLight,
    xAxisFormatter: function xAxisFormatter(x) {
      return "$" + abbr(x);
    }
  }));
};
RefinanceBarGraphBase.propTypes = process.env.NODE_ENV !== "production" ? {
  containerWidth: PropTypes.number.isRequired
} : {};

// Default height & width are the dimensions of the refinance bar graph as rendered on an iPhone X, our most
// common device type according to GA data as of 10/5/2021
var DimensionedThemedRefinanceBarGraph = withDimensions(RefinanceBarGraphBase, {
  defaultHeight: 150,
  defaultWidth: 311
});
var RefinanceBarGraph = PropInterpolatorWrapper(DimensionedThemedRefinanceBarGraph);
var RefinanceBarGraph$1 = RefinanceBarGraph;

export { RefinanceBarGraph$1 as default };
